import {
  ChangeDetectionStrategy,
  Component, Inject, inject,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'eurogard-copy-timeslot-dialog',
  standalone: true,
  imports: [
    MatButton,
    MatSlideToggle,
    MatDialogModule,
  ],
  templateUrl: './copy-timeslot-dialog.component.html',
  styleUrl: './copy-timeslot-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyTimeslotDialogComponent {
  protected matDialogRef = inject(MatDialogRef);
  protected dayValues = Array.from({ length: 7 }, () => false);

  protected daysOfTheWeek = [
    $localize`Monday`,
    $localize`Tuesday`,
    $localize`Wednesday`,
    $localize`Thursday`,
    $localize`Friday`,
    $localize`Saturday`,
    $localize`Sunday`,
  ];

  constructor(@Inject(MAT_DIALOG_DATA) public data: { dayIndex: number }) {
  }

}
